import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../../shared/_services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private urlToNotUse: string = '';  
  loaderExcludeUrl: Observable<string> = this.loaderService.loaderExcludeUrl;

  constructor(private loaderService: LoaderService) {
    this.loaderService.loaderExcludeUrl.subscribe((value:any) => {
        this.urlToNotUse = value
    })
  } 

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        this.loaderService.isLoading.next(this.requests.length > 0);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requests.push(req);
        if (this.urlToNotUse && req.url.indexOf(this.urlToNotUse) !== -1) {
            this.requests.splice(this.requests.indexOf(req), 1);
            this.loaderService.isLoading.next(this.requests.length > 0);
            return next.handle(req);
        }

        this.loaderService.isLoading.next(true);

        return new Observable<HttpEvent<any>>((observer) => {
            const subscription = next.handle(req).subscribe(
                (event) => {
                    if (event instanceof HttpResponse) {
                        this.removeRequest(req);
                        observer.next(event);
                    }
                },
                (err) => {
                    this.removeRequest(req);
                    observer.error(err);
                },
                () => {
                    this.removeRequest(req);
                    observer.complete();
                }
            );

        // remove request from queue when cancelled
        return () => {
            this.removeRequest(req);
            subscription.unsubscribe();
        };
        });
    }
}